import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Redirect, useHistory } from "react-router-dom";
import { useIntl } from "react-intl";
import { finishRegistration } from "./registrationSlice";
import Auth from "../../api/auth";
import {
  IonContent,
  IonPage,
  IonButton,
  IonText,
  IonCard,
  IonHeader,
  IonToolbar,
  IonTitle,
  IonLoading,
  useIonToast,
  IonIcon,
} from "@ionic/react";
import { useForm } from "react-hook-form";
import InputItem from "../../components/formItems/InputItem";
import CheckBoxItem from "../../components/formItems/CheckBoxItem";
import { ErrorMessage } from "@hookform/error-message";
import { warningOutline } from "ionicons/icons";

const ChangePassword = () => {
  const intl = useIntl();
  const history = useHistory();
  const dispatch = useDispatch();
  const [present] = useIonToast();
  const [error, setError] = useState(null);
  const [mode, setMode] = useState(null);
  const {
    handleSubmit,
    control,
    formState: { errors },
    watch,
  } = useForm({
    criteriaMode: "all",
  });
  const password = useRef({});
  password.current = watch("password", "");
  const [tenantId, setTenantId] = useState({});
  const { invitationAccepted, error: registrationError } = useSelector(
    (state) => state.registration
  );
  const registrationInProgress = useSelector(
    (state) => state.registration.registrationInProgress
  );
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const modeParam = urlParams.get("mode");
    setMode(modeParam);
    const tenantId = urlParams.get("tenantId");
    if (!tenantId) {
      setError("Wrong registration link");
    }
    setTenantId(tenantId);
    if (modeParam !== "resetPassword") {
      Auth.signOut();
    }
  }, []);

  const onFinish = async (values) => {
    const urlParams = new URLSearchParams(window.location.search);
    if (mode === "resetPassword") {
      var actionCode = urlParams.get("oobCode");
      Auth.changePassword(tenantId, actionCode, values.password)
        .then(() => {
          history.push("/login");
          present({
            color: "success",
            duration: 2000,
            position: "top",
            message: intl.formatMessage({
              id: "app.mobile.forms.user.changePassSuccessNotify",
            }),
          });
        })
        .catch((err) => {
          setError(err);
          present({
            color: "danger",
            duration: 2000,
            position: "top",
            message: intl.formatMessage({
              id: "app.mobile.forms.user.changePassFailedNotify",
            }),
          });
        });
    } else {
      const params = {
        tenantId,
        email: values.username,
        newPassword: values.password,
      };
      dispatch(finishRegistration(params));
    }
  };

  const ErrorContent = () => (
    <IonCard>
      <div
        style={{
          padding: "16px 16px 0 16px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
        }}
      >
        <IonIcon
          style={{ fontSize: "40px", color: "red" }}
          icon={warningOutline}
          slot="start"
        />
        <IonText>
          <p>
            {intl.formatMessage({
              id: "app.errors.failFetchInvitation",
            })}
          </p>
        </IonText>
      </div>
      <div className="ion-padding">
        <IonButton
          expand="block"
          className="ion-margin-top"
          routerLink={`/login`}
        >
          {intl.formatMessage({
            id: "app.mobile.actions.goHome",
          })}
        </IonButton>
      </div>
    </IonCard>
  );

  // if (!tenantId) {
  //   return null; //show loading
  // }

  if (invitationAccepted) {
    return <Redirect to="/" />;
  }

  const passwordReg = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{6,20}$/;
  const emailReg = /^([-!#-'*+/-9=?A-Z^-~]+(\.[-!#-'*+/-9=?A-Z^-~]+)*|"([]!#-[^-~ \t]|(\\[\t -~]))+")@[0-9A-Za-z]([0-9A-Za-z-]{0,61}[0-9A-Za-z])?(\.[0-9A-Za-z]([0-9A-Za-z-]{0,61}[0-9A-Za-z])?)+$/;

  const CheckBoxLabel = () => (
    <div style={{ display: "flex", alignItems: "center" }}>
      <IonText>
        <p>
          {intl.formatMessage({
            id: "app.mobile.forms.user.read_statement",
          })}
        </p>
      </IonText>
      <IonButton fill="clear">
        {intl.formatMessage({
          id: "app.mobile.forms.user.terms",
        })}
      </IonButton>
    </div>
  );

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar color="primary">
          <IonTitle>
            {intl.formatMessage({
              id: "app.mobile.create_password",
            })}
          </IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent>
        {error || registrationError || !tenantId ? (
          <ErrorContent />
        ) : (
          <IonCard>
            <div style={{ padding: "16px 16px 0 16px" }}>
              <IonText color="muted">
                <h2>
                  {intl.formatMessage({
                    id: "app.mobile.forms.user.set_password_title",
                  })}
                </h2>
                <p>
                  {intl.formatMessage({
                    id: "app.mobile.forms.user.set_password_subtitle",
                  })}
                </p>
              </IonText>
            </div>
            <form onSubmit={handleSubmit(onFinish)}>
              <InputItem
                name="username"
                control={control}
                label={intl.formatMessage({
                  id: "app.mobile.forms.user.username",
                })}
                rules={{
                  required: `${intl.formatMessage({
                    id: "app.mobile.forms.user.username",
                  })} ${intl.formatMessage({
                    id: "app.mobile.forms.requiredMessage",
                  })}`,
                  pattern: {
                    value: emailReg,
                    message: intl.formatMessage({
                      id: "app.mobile.forms.emailMessage",
                    }),
                  },
                }}
              />
              <div className="errors_container">
                <ErrorMessage
                  errors={errors}
                  name="username"
                  render={({ messages }) =>
                    messages &&
                    Object.entries(messages).map(([type, message]) => (
                      <p key={type}>{message}</p>
                    ))
                  }
                />
              </div>
              <InputItem
                name="password"
                control={control}
                label={intl.formatMessage({
                  id: "app.mobile.forms.user.password",
                })}
                rules={{
                  required: `${intl.formatMessage({
                    id: "app.mobile.forms.user.username",
                  })} ${intl.formatMessage({
                    id: "app.mobile.forms.requiredMessage",
                  })}`,
                  pattern: {
                    value: passwordReg,
                    message: intl.formatMessage({
                      id: "app.mobile.forms.strongPasswordMessage",
                    }),
                  },
                }}
              />
              <div className="errors_container">
                <ErrorMessage
                  errors={errors}
                  name="password"
                  render={({ messages }) => {
                    return (
                      messages &&
                      Object.entries(messages).map(([type, message]) => (
                        <p key={type}>{message}</p>
                      ))
                    );
                  }}
                />
              </div>
              <InputItem
                name="confirm"
                control={control}
                label={intl.formatMessage({
                  id: "app.mobile.forms.user.confirm_password",
                })}
                rules={{
                  required: `${intl.formatMessage({
                    id: "app.mobile.forms.user.confirm_password",
                  })} ${intl.formatMessage({
                    id: "app.mobile.forms.requiredMessage",
                  })}`,
                  validate: (value) =>
                    value === password.current ||
                    intl.formatMessage({
                      id: "app.mobile.forms.user.password_not_match",
                    }),
                }}
              />
              <div className="errors_container">
                <ErrorMessage
                  errors={errors}
                  name="confirm"
                  render={({ messages }) =>
                    messages &&
                    Object.entries(messages).map(([type, message]) => (
                      <p key={type}>{message}</p>
                    ))
                  }
                />
              </div>

              <CheckBoxItem
                name="agreement"
                control={control}
                label={<CheckBoxLabel />}
                rules={{
                  validate: (value) =>
                    value === true ||
                    intl.formatMessage({
                      id: "app.mobile.forms.user.should_accept_agreement",
                    }),
                }}
              />
              <div className="errors_container">
                <ErrorMessage
                  errors={errors}
                  name="agreement"
                  render={({ messages }) =>
                    messages &&
                    Object.entries(messages).map(([type, message]) => (
                      <p key={type}>{message}</p>
                    ))
                  }
                />
              </div>

              <div className="ion-padding">
                <IonButton
                  expand="block"
                  className="ion-margin-top"
                  type="submit"
                >
                  {intl.formatMessage({
                    id: "app.mobile.actions.create",
                  })}
                </IonButton>
              </div>
            </form>
          </IonCard>
        )}
        <IonLoading isOpen={registrationInProgress} />
      </IonContent>
    </IonPage>
  );
};

export default ChangePassword;
